import { isDevelopment } from "config/env";
import React from "react";

export const useIsDevelopment = () => {
  const [_isDevelopment] = React.useState(isDevelopment())

  return _isDevelopment
}
